.pill {
  height: 40px;
  background: var(--palettePrimary2);
  border-radius: var(--radiusMd);
  cursor: default;

  &:focus-visible {
    outline: 0;
    border: 1px solid var(--paletteBlue0);
    box-shadow: inset 0 0 0 1px var(--paletteBlue0);
  }
}

$engagement-color: #6a82c5;
$engagement-light-color: rgba($engagement-color, 0.4);
$role-color: #00a699;
$role-light-color: rgba($role-color, 0.4);

.engagementPartiallyBooked {
  background: $engagement-light-color;
  border: 2px solid $engagement-color;
}

.engagementNotBooked {
  background: var(--paletteWhite0);
  border: 2px solid $engagement-color;
}

.engagementBooked {
  background: $engagement-color;
}

.rolePartiallyBooked {
  background: $role-light-color;
  border: 2px solid $role-color;
}

.roleBooked {
  background: $role-color;
}

.roleNotBooked {
  background: var(--paletteWhite0);
  border: 2px solid $role-color;
}

.misalignmentPill {
  background: transparent;
  border: 2px dashed var(--paletteRed0);
}

.bookingPill {
  display: flex;
  align-items: center;
  gap: var(--spacingSm);
  padding: 0 var(--spacingSm);

  &.center {
    justify-content: center;
  }
}
